import * as React from 'react';
import { Component } from 'react';
import Moment from 'react-moment';
import { withStyles } from '@material-ui/core/styles';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Box, LinearProgress } from '@material-ui/core';
import { userActions } from '../../common/users/';
import { ConnectedComponent } from "../../components/ConnectedComponent";
const mapStateToProps = (state) => {
    return { updatedByUsers: state.users.usersById, isLoading: state.users.usersById.isLoading, loadStarted: state.users.usersById.loadStarted };
};
const mapDispatchToProps = (dispatch) => ({
    getUserById: (userId) => dispatch(userActions.getUserById(userId))
});
const { propsGeneric, connect } = new ConnectedComponent().mapToProps(mapStateToProps, mapDispatchToProps);
const styles = {
    basicDataTable: {
        '& .MuiTableCell-root': {
            fontSize: 12,
            borderBottom: 'none'
        },
        '& .MuiTableRow-root': {
            '&.printHide': {
                '@media print': {
                    display: 'none'
                }
            }
        },
        maxWidth: 740,
        '& td:first-child': {
            fontWeight: 'bold',
            width: '23%'
        },
        marginBottom: 30
    }
};
class EditMatchResultBasicDataComponent extends Component {
    constructor(props) {
        super(props);
        this.formatUserTime = this.formatUserTime.bind(this);
        this.formatDivisionText = this.formatDivisionText.bind(this);
        this.state = {
            match: props.match,
            team1UpdatedByUser: undefined,
            team2UpdatedByUser: undefined
        };
    }
    componentDidMount() {
        const allData = this.props.match;
        const match = allData.match;
        let userLoading = false;
        if (match.resultUpdatedByUserId) {
            this.props.getUserById(match.resultUpdatedByUserId).then(() => {
                this.team1UpdateTime = this.props.match.match.resultUpdated;
                this.setState({
                    team1UpdatedByUser: this.props.updatedByUsers.user
                });
            });
            userLoading = true;
        }
        if (match.separateTeamRegistration && match.team2UpdatedByUserId) {
            this.props.getUserById(match.team2UpdatedByUserId).then(() => {
                this.team2UpdateTime = this.props.match.match.team2Updated;
                this.setState({
                    team2UpdatedByUser: this.props.updatedByUsers.user
                });
            });
            userLoading = true;
        }
        if (!userLoading) {
            this.setState({});
        }
    }
    formatUserTime() {
        const makeRow = (user, updateTime, text) => {
            if (user) {
                return (React.createElement(Box, { component: TableRow, key: user.userId + text, displayPrint: "none", className: "printHide" },
                    React.createElement(TableCell, null, text),
                    React.createElement(TableCell, null,
                        React.createElement("a", { href: "/DBF/Bruger/VisProfil/?userid={user.userId}" }, user.name),
                        "\u00A0",
                        React.createElement("a", { href: "mailto:{user.email}" }, user.email),
                        "\u00A0",
                        React.createElement(Moment, { format: "DD-MM-YYYY HH:mm" }, updateTime))));
            }
        };
        const rows = [];
        rows.push(makeRow(this.state.team1UpdatedByUser, this.team1UpdateTime, "Indberettet"));
        rows.push(makeRow(this.state.team2UpdatedByUser, this.team2UpdateTime, "Udehold indberettet"));
        return rows;
    }
    formatDivisionText() {
        const allData = this.props.match;
        const match = allData.match;
        return (React.createElement("span", null,
            allData.regions.map((region) => React.createElement("span", { key: region.regionId },
                region.shortName,
                ", ")),
            " ",
            match.divisionName,
            " ",
            match.groupName));
    }
    render() {
        const match = this.props.match.match;
        const { classes } = this.props;
        return (React.createElement(TableContainer, null,
            React.createElement(Table, { "aria-label": "league match basic data", size: "small", className: classes.basicDataTable },
                React.createElement(TableHead, null),
                React.createElement(TableBody, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "Kampnr"),
                        React.createElement(TableCell, null, match.leagueMatchId)),
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "Runde"),
                        React.createElement(TableCell, null,
                            match.roundIndex,
                            " ",
                            React.createElement(Moment, { format: "DD-MM-YYYY" }, match.roundDate))),
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "R\u00E6kke"),
                        React.createElement(TableCell, null, this.formatDivisionText())),
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "Tid"),
                        React.createElement(TableCell, null,
                            React.createElement(Moment, { format: "DD-MM-YYYY HH:mm" }, match.matchTime))),
                    this.props.loadStarted && this.props.isLoading ? React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: 2 },
                            React.createElement(LinearProgress, null))) : this.formatUserTime()))));
    }
}
const EditMatchResultBasicData = withStyles(styles, { withTheme: false })(connect(EditMatchResultBasicDataComponent));
export default EditMatchResultBasicData;
